import {Component, input} from '@angular/core';
import {ChartData, ChartOptions} from 'chart.js';
import {UIChart} from 'primeng/chart';
import {ProgressDashboardContainerComponent} from '../progress-dashboard-container/progress-dashboard-container.component';

@Component({
  selector: 'app-progress-dashboard-chart-container',
  imports: [UIChart, ProgressDashboardContainerComponent],
  templateUrl: './progress-dashboard-chart-container.component.html',
})
export class ProgressDashboardChartContainerComponent {
  readonly label = input.required<string>();
  readonly data = input.required<ChartData<'pie' | 'bar'> | null>();
  readonly type = input.required<
    'bar' | 'line' | 'scatter' | 'bubble' | 'pie' | 'doughnut' | 'polarArea' | 'radar' | undefined
  >();

  readonly options = input<ChartOptions>({});
}
